import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";
import CommodityTabs from "../CommodityTabs";

export function QuoteBand({ quote }) {
  const [ref, visible] = useReveal();
  return (
    <section className="relative bg-[#10271a] text-[#f6f1e7] overflow-hidden grain">
      <img src={quote.image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
      <div className="relative mx-auto max-w-[1100px] px-6 md:px-10 py-28 md:py-40 text-center">
        <div ref={ref} className={`reveal ${visible ? "in-view" : ""}`}>
          <p className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-[1.2]">
            "{quote.text} <em className="italic text-[#e9d9bf]">{quote.emphasis}</em> {quote.tail}"
          </p>
          <p className="mt-10 text-[#b08a5f] text-xs tracking-[0.25em] uppercase">Leslie West Africa · Sourced Directly · Traded Responsibly</p>
        </div>
      </div>
    </section>
  );
}

export function ExploreBand({ active }) {
  const [ref, visible] = useReveal();
  return (
    <section className="bg-[#f6f1e7] py-20 md:py-24 border-t border-[#10271a]/5" data-testid="explore-band">
      <div ref={ref} className={`mx-auto max-w-[1400px] px-6 md:px-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8 reveal ${visible ? "in-view" : ""}`}>
        <div>
          <p className="text-[#7c5230] text-xs tracking-[0.25em] uppercase mb-4">Keep watching</p>
          <h2 className="font-display text-3xl md:text-5xl font-light leading-[1.05] text-[#10271a]">
            Follow another <em className="italic text-[#1f4a33]">journey.</em>
          </h2>
        </div>
        <CommodityTabs active={active} variant="light" />
      </div>
    </section>
  );
}

export function PartnershipBand() {
  const [ref, visible] = useReveal();
  return (
    <section className="bg-[#1f4a33] text-[#f6f1e7]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:items-end reveal ${visible ? "in-view" : ""}`}>
          <div>
            <p className="text-[#b08a5f] text-xs tracking-[0.25em] uppercase mb-6">05 · Wholesale</p>
            <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-light leading-[1.0]">
              Let's build something <em className="italic text-[#e9d9bf]">lasting.</em>
            </h2>
            <p className="mt-7 text-[#f6f1e7]/75 text-lg max-w-md leading-relaxed">
              Container loads, private label or long-term supply — tell us the commodities, grades and volumes you need and our trade desk will build the offer.
            </p>
          </div>
          <div className="lg:justify-self-end">
            <Link
              to="/wholesale"
              data-testid="partnership-wholesale-link"
              className="group inline-flex items-center gap-3 bg-[#f6f1e7] text-[#10271a] px-8 py-4 rounded-full text-sm tracking-[0.12em] uppercase font-semibold hover:bg-white transition-colors"
            >
              Start a wholesale enquiry
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
            <p className="mt-4 text-[#f6f1e7]/55 text-sm">Sourced directly · Shipped worldwide</p>
          </div>
        </div>
      </div>
    </section>
  );
}
